export const whatsappMessagingLimits = {
  TIER_50: 50,
  TIER_250: 250,
  "TIER_0.25K": 250,
  TIER_1K: 1000,
  TIER_10K: 10000,
  TIER_100K: 100000,
  TIER_UNLIMITED: 999999,
};
